var normalizeComponent = require("!../../../../../snoozy/node_modules/vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = require("!!babel-loader?{\"cacheDirectory\":true,\"presets\":[[\"env\",{\"modules\":false,\"targets\":{\"browsers\":[\"> 2%\"],\"uglify\":true}}]],\"plugins\":[\"transform-object-rest-spread\",[\"transform-runtime\",{\"polyfill\":false,\"helpers\":false}]]}!../../../../../snoozy/node_modules/vue-loader/lib/selector?type=script&index=0!./HtmlLink.vue")
/* template */
var __vue_template__ = require("!!../../../../../snoozy/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-08ab5f47\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../../../snoozy/node_modules/vue-loader/lib/selector?type=template&index=0!./HtmlLink.vue")
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ../default-js/js/components/common/LinkElements/HtmlLink.vue
// module id = sLK1
// module chunks = 17